import { styled } from '@mui/material'

export const OrganisationMenuItemButtonWrapper = styled('button')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: 12,
  padding: 12,
  paddingLeft: 16,
  border: 'none',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  transition: 'background-color 0.15s',
  borderTop: '1px solid #CDCED9',
  position: 'relative',

  '&:hover': {
    backgroundColor: theme.palette.neutralLight[100],
  },

  '&[data-isFirstSearchResult=true]': {
    backgroundColor: theme.palette.neutralLight[50],

    '&:after': {
      content: '"Enter ↵"',
      fontSize: 10,
      fontWeight: 'bold',
      color: theme.palette.neutralLight[900],
      lineHeight: 1,
      padding: 3,
      position: 'absolute',
      right: 0,
      top: 0,
      transform: 'translateY(-25%) translateX(-10%)',
      backgroundColor: theme.palette.neutralLight[100],
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: theme.palette.neutralLight[700],
      borderRadius: 3,
      boxShadow: ' rgba(0, 0, 0, 0.15) 1px 1px 1px',
    },
  },
}))
